<div class="body">
    <div class="nav">
        <app-navbar></app-navbar>
    </div>
    <div class="main">
            <h2>Coming Soon!</h2>
            <p>Registrations are open now!</p>
            <button routerLink="/reg" class="btn inverse">Click Here to Register!</button>
    </div>
    <div class="footing">
        <app-footer></app-footer>
    </div>
</div>